import { request } from '@umijs/max';
import type {
  FetchRecommendTemplateRes,
  IQueryTask,
  ISearch,
  ITask,
  ITemplate,
  ITemplateDetail,
  ITemplateGroup,
} from './type';

// ================= 模板 =================

/**
 * 查询模板分组列表
 */
export const getTemplateGroup = (params: {
  group_type: number;
  page?: number;
  size?: number;
}) => {
  return request<IRes<IList<ITemplateGroup>>>(
    '/supertext-java/template_groups',
    {
      params,
    },
  );
};

/**
 * @description 创建模板
 * @deprecated 创建模版统一采用common模块，后续将移除该方法
 */
export const createTemplate = (params: any) => {
  return request<IRes<IList<ITemplate>>>('/supertext-java/templates', {
    method: 'POST',
    data: params,
  });
};

/** 查询模板列表 */
export const getTemplates = (
  params: ISearch,
): Promise<IRes<IList<ITemplate>>> => {
  return request('/supertext-java/templates', {
    methods: 'GET',
    params,
  });
};

/** 获取模板详情 */
export const getTemplateDetail = (templateCode: string) => {
  return request<IRes<ITemplateDetail>>(
    `/supertext-java/templates/${templateCode}`,
  );
};

// ================= 模板收藏 =================

/** 添加模板收藏 */
export const addFavorites = (templateCode: string) => {
  return request<IRes<boolean>>(
    `/supertext-java/favorites/templates/${templateCode}`,
    {
      method: 'PUT',
    },
  );
};

/** 取消模板收藏 */
export const deleteFavorites = (templateCode: string) => {
  return request<IRes<boolean>>(
    `/supertext-java/favorites/templates/${templateCode}`,
    {
      method: 'DELETE',
    },
  );
};

/** 查询模板收藏列表 */
export const getFavorites = (params: { page: number; size: number }) => {
  return request<IRes<IList<ITemplate>>>(
    '/supertext-java/favorites/templates',
    { params },
  );
};

// ================= 任务 =================

/** 查询任务列表 */
export const fetchTaskList = (params: IQueryTask, signal?: AbortSignal) => {
  return request<IRes<IList<ITask>>>(`/supertext-java/tasks`, {
    params,
    signal,
  });
};

/** 删除任务 */
export const deleteTask = (taskCodes: string) => {
  return request<IRes<ITask>>(`/supertext-java/tasks/${taskCodes}`, {
    method: 'DELETE',
  });
};

/** 获取任务详情 */
export const fetchTaskDetail = (taskCode: string) => {
  return request<IRes<ITask>>(`/supertext-java/tasks/${taskCode}`);
};

/** 获取OCR任务详情 */
export const fetchOcrTaskDetail = (taskCode: string) => {
  return request<IRes<void>>(`/supertext-py/api/ocr/task/${taskCode}`, {
    params: { id: taskCode },
  });
};

export const createTask = (value: {
  template_codes: string[];
  batch_id?: number;
  tasks?: { task_name: string; file_hash_list: string[] }[];
  template_categories?: string[];
}) => {
  return request<IRes<string[]>>(`/supertext-java/tasks`, {
    method: 'POST',
    data: value,
  });
};

export const createWorkspaceTask = (
  workSpaceUid: string,
  value: {
    template_codes: string[];
    batch_id?: number;
    tasks?: { task_name: string; file_hash_list: string[] }[];
  },
) => {
  return request<IRes<string[]>>(
    `/supertext-java/workspace/tasks/${workSpaceUid}`,
    {
      method: 'POST',
      data: value,
    },
  );
};

export const createSceneTask = (value: {
  template_code: string;
  name?: string;
  workspace_uid?: string;
  node_head?: { type: number; name: string; uid: string; avatar: string }[];
}) => {
  return request<
    IRes<{ name: string; unique_num: string; template_code: string }>
  >(`/supertext-java/scene/tasks/`, { method: 'POST', data: { ...value } });
};
export const fetchRecommendTemplate = (params: {
  keyword: string;
  size?: number;
}) => {
  return request<IRes<IList<FetchRecommendTemplateRes[]>>>(
    '/supertext-java/templates/recommend',
    {
      params,
    },
  );
};

/**
 * 下载审核结果
 */
export const downloadTaskResult = (taskCode: string) => {
  return request<IRes<string>>(`/supertext-java/tasks/${taskCode}/result`);
};

export * from './type';
